// extracted by mini-css-extract-plugin
export default {"buttons":"contact-details_buttons__mDVLw","form":"contact-details_form__M4Way"};